/**
 * Format util file that centralizes formatting functions that are used in multiple components
 */

/**
 * Function to format the request to send to the fulfillment service
 * Used in both multiple and single estimates pages
 * @param {Object} estimateCopy copy of estimate info returned from price service
 * @param {Array} scenarios list of all estimate scenarios from the response from price service
 * @param {Object} accumulators contains deductible and oopMax info
 * @param {Object} serviceInfo selected service
 * @param {Array} providers list of providers associated with each estimate scenario
 * @param {Object} subscriberId member's subscriber id from ben service, saved in context
 * @param {Object} memberDetails response from benefits service
 * @param {Object} formValues context of items in the initialFormValues
 * @returns {Object} formatted object of estimate info to send to fulfillment service
 */
export const formatFulfillmentRequest = (
    estimateCopy,
    scenarios,
    serviceInfo,
    providers,
    memberDetails,
    formValues,
    accumIndex = -1
) => {
    const scenarios20 = [];
    scenarios.slice(0, 20).map((singleScenario, index) => {
        singleScenario.disclaimers = [];

        singleScenario.claims = singleScenario.claims.filter((claim) => claim.costShare);

        singleScenario.claims.map((claim) => {
            claim.procedures.map((procedure) => {
                procedure.procedureCode.description = serviceInfo?.name;
                if (providers[index]) {
                    if (procedure?.provider?.providerType?.toUpperCase() == 'PERSON') {
                        if (providers[index]?.unTranslatedText) {
                            procedure.provider.name = providers[index]?.unTranslatedText;
                        } else {
                            procedure.provider.name = 'Physician';
                        }
                    } else {
                        if ((procedure.provider.name = procedure?.provider?.organizationName)) {
                            procedure.provider.name = procedure?.provider?.organizationName;
                        } else {
                            procedure.provider.name = 'Facility';
                        }
                    }
                } else {
                    procedure.provider.name = '';
                }
            });
        });
        scenarios20.push(singleScenario);
    });

    // if we send an accumulator index in request, use that one, otherwise default to finding the in-network accumulator
    const accumulatorIndex =
        accumIndex > -1
            ? accumIndex
            : estimateCopy.accumulators
            ? estimateCopy.accumulators.findIndex((cost) => cost.tier === 'IN-NETWORK')
            : null;

    const accumulators = estimateCopy.accumulators?.[accumulatorIndex];
    const accumulatorInfo = { deductibleSpent: null, oopMaxSpent: null };

    if (accumulators?.deductible) {
        accumulatorInfo.deductibleSpent = Math.round(
            accumulators.deductible.yearlyMax - accumulators.deductible.remaining
        );
    }

    if (accumulators?.oopMax) {
        accumulatorInfo.oopMaxSpent = Math.round(
            accumulators.oopMax.yearlyMax - accumulators.oopMax.remaining
        );
    }

    const { groupNumber, cae, subscriberId, alternateId } = formValues;

    estimateCopy.member.cae = cae.value;
    estimateCopy.member.memberId = alternateId.value;
    estimateCopy.member.subscriberId = subscriberId.value;

    if (Boolean(memberDetails?.popConfig?.fulfillmentGroupNumIndicator)) {
        estimateCopy.member.groupNumber = groupNumber?.value;
    }

    return {
        cpttRequestId: estimateCopy.cpttRequestId,
        sourceCode: memberDetails.sourceCode,
        member: estimateCopy.member,
        scenarios: scenarios20,
        accumulators: accumulatorInfo,
    };
};

export const convertFirstLetterToUpperCase = (string) => {
    return string?.length > 0 ? string[0].toUpperCase() + string.substring(1) : string;
};
